import { useState } from "react";

const EmailSignup = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = async () => {
    setError("");

    if (!email) {
      setError("Please enter an email address");
      return;
    }

    if (!validateEmail(email)) {
      setError("Please enter a valid email address");
      return;
    }

    try {
      const response = await fetch("https://iooflivermore219.org/trigger", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email })
      });

      if (response.ok) {
        setSuccess(true);
        setEmail("");
      } else {
        setError("Something went wrong, please try again");
      }
    } catch (error) {
      setError("Something went wrong, please try again");
    }
  };

  return (
    <div className="flex flex-col items-center gap-2 mt-4 md:mt-8">
      <div className="flex flex-col md:flex-row gap-2 w-full">
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="input input-bordered w-full"
        />
        <button onClick={handleSubmit} className="btn font-heading bg-[#012F47] border-[#012F47] hover:bg-[#631F07] text-white">
          Subscribe
        </button>
      </div>
      {error && <p className="text-red-500 text-sm">{error}</p>}
      {success && <p className="text-green-500 text-sm">Thank you for signing up!</p>}
    </div>
  );
};

export default EmailSignup;